// src/utils/permission.js
import store from "../../store/index";

/**
 * 检查当前用户是否拥有指定的权限码
 * @param {string} permission - 权限码，如 'btn:add_station'
 * @returns {boolean} 是否拥有权限
 */
export function hasPermission(permission) {
  const permissions = store.state?.user?.permissions || [];
  return permissions.includes(permission);
}